import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ResponseMessage } from '../model/FormsEntity/response';
import { env } from 'process';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParkBookingService {
  private parkBooking: string;
  private documentUrl: string;
  private parkBookingWF: string;
  constructor(private http:HttpClient) { 
    this.parkBooking = environment.baseUrl + 'parkBooking/';
    this.parkBookingWF = environment.wflowUrl + 'parkBooking/workflow/';
    this.documentUrl = environment.baseUrl + 'fileUtils/getDownloadedFile'
    

  }
  public saveParkBookingDetails(data){
    return this.http.post<ResponseMessage>(this.parkBooking +'saveParkBookingDetails',data);
  }
  // payment gateway
  public makePaymentmaharastra(model) {
    return this.http.post<any>(environment.baseUrl+'payment/maharastra/makePayment', model);
  }

  public getParkBasedOnCategory(id){
    return this.http.get<any>(this.parkBooking +'getParkBasedOnCategory/'+id);
  }
  public checkAvailabilityList(data){
    return this.http.post<ResponseMessage>(this.parkBooking +'checkAvailabilityList',data);
  }
  public getParkBookingDetails(id){
    return this.http.get<any>(this.parkBooking +'getParkBookingDetails/'+id);
  }
  public getParkBookingList(id,roleName){
    const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName);
    return this.http.get<any>(this.parkBooking +'getParkBookingList/',{params});
  }
  
  public saveParkBookingDeficiencyMemo(data){
    return this.http.post<any>(this.parkBooking +'saveParkBookingDeficiencyMemo',data);
  }
  public getParkBookingDeficiencyMemo(applicationId){
    const params = new HttpParams()
      .set('applicationId', applicationId);
    return this.http.get<any>(this.parkBooking +'getParkBookingDeficiencyMemo',{params});
  }
  public getPaymentDetail(applicationId){
    
    return this.http.get<any>(environment.baseUrl +'payment/maharastra/getPaymentDetailsByAppNo/'+applicationId);
  }
  public parkBookingProcess(data){
    return this.http.post<any>(this.parkBookingWF +'parkBookingProcess',data);
  }
  //getWorkFlowHistory
  public getWorkFlowStatusByAppNo(id){
    return this.http.get<any>(this.parkBookingWF +'getWorkFlowHistory/'+id);
  }
  public numberOfApplication(data){
    return this.http.post<any>(this.parkBookingWF +'numberOfApplication',data);
  }
  public refundCalculator(appno){
    return this.http.get<any>(this.parkBooking +'refundCalculator/'+appno);
  }
  public cancelParkBookingByApplicantWithoutPay(appNo){
    return this.http.get<any>(this.parkBooking +'cancelParkBookingByApplicant/'+appNo);
  }
  public damageUpdate(data){
    return this.http.post<any>(this.parkBooking +'damageUpdate',data);
  }
  public generateImage(fileName) {
    const httpOptions = {
        'responseType': 'arraybuffer' as 'json'
       
    };
    return this.http.post<any>(this.documentUrl , fileName, httpOptions);
  }
  getMarqueeDescription(id): Observable<string> {
    const params = new HttpParams().set('id',id)
    return this.http.get<string>(this.parkBooking + 'getMarqueeDescription/',{params});
  }
  public downloadZip(appNo)
  {
      return this.http.get<any>(this.parkBooking + 'getDownladedZipPark/'+appNo );
  }
}
